// extracted by mini-css-extract-plugin
export default {"placeholderImage":"ListView_placeholderImage__cReZ4","list":"ListView_list__dd257","row":"ListView_row__psLMM"};